import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

interface SalesPerformanceProps {
    goalsComparison: Array<{
        branch: string;
        Meta: number;
        Real: number;
    }>;
}

export function SalesPerformance({ goalsComparison }: SalesPerformanceProps) {
    const currentMonth = new Date().toLocaleString('es-ES', { month: 'long' });
    const capitalizedMonth = currentMonth.charAt(0).toUpperCase() + currentMonth.slice(1);

    return (
        <div className="rounded-lg border border-slate-200 bg-white p-6">
            <h3 className="mb-4 font-semibold text-slate-900">
                Metas vs Ventas Reales ({capitalizedMonth})
            </h3>
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={goalsComparison}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                    <XAxis dataKey="branch" stroke="#64748b" />
                    <YAxis stroke="#64748b" />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: '#fff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '8px',
                        }}
                    />
                    <Legend />
                    <Bar
                        dataKey="Meta"
                        fill="#94a3b8"
                        name="Meta"
                        radius={[4, 4, 0, 0]}
                    />
                    <Bar dataKey="Real" name="Real" radius={[4, 4, 0, 0]}>
                        {goalsComparison.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.Real >= entry.Meta ? '#10b981' : '#f59e0b'}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}